document.addEventListener("DOMContentLoaded", function () {
  const root = document.querySelector('.template-page-impact-new');
  if (!root) return;

  const sectionWrappers = Array.from(
    root.querySelectorAll('.section-wrapper:has(.ctm-sticky-service.ctm-sticky-service-desktop)')
  );
  if (!sectionWrappers.length) return;

  const getHeaderOffset = () => {
    const raw = getComputedStyle(document.body).getPropertyValue('--header-group-height');
    const parsed = parseFloat(raw);
    const offset = parsed + 20;

    if (Number.isFinite(offset) && offset > 0) {
      return offset;
    }

    return window.matchMedia('(min-width: 750px)').matches ? 100 : 64;
  };

  let initialized = false;

  /**
   * @param {Element} sectionWrapper
   */
  function initImpactTimelineSection(sectionWrapper) {
    const trigger = sectionWrapper.querySelector('.ctm-sticky-service.ctm-sticky-service-desktop');
    if (!trigger) return;

    /** Scope to desktop sticky subtree so mobile duplicate blocks are not included (avoids huge pin distance). */
    const steps = Array.from(trigger.querySelectorAll('.section-image-with-text-block'));
    const phoneImages = Array.from(trigger.querySelectorAll('.infographic-step'));

    if (!steps.length) return;

    let currentIndex = -1;

    /**
     * @param {number} index
     */
    function activateStep(index) {
      if (index === currentIndex || index < 0 || index >= steps.length) return;
      currentIndex = index;

      steps.forEach((/** @type {HTMLElement} */ step, /** @type {number} */ i) => {
        if (i === index) {
          step.classList.add("active");
        } else {
          step.classList.remove("active");
        }
      });

      phoneImages.forEach((img, i) => {
        if (i === index) {
          img.classList.add("active");
        } else {
          img.classList.remove("active");
        }
      });
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      currentIndex = -1;
      activateStep(0);
      return;
    }

    const gsapLib = /** @type {any} */ (window)['gsap'];
    const ScrollTriggerPlugin = /** @type {any} */ (window)['ScrollTrigger'];

    if (!gsapLib || !ScrollTriggerPlugin) {
      return;
    }

    gsapLib.registerPlugin(ScrollTriggerPlugin);

    /** Scroll length matches stacked step blocks (not viewport multiples). */
    const measurePinScrollPx = () => {
      const firstEl = /** @type {HTMLElement} */ (steps[0]);
      const lastEl = /** @type {HTMLElement} */ (steps[steps.length - 1]);
      const topRect = firstEl.getBoundingClientRect();
      const botRect = lastEl.getBoundingClientRect();
      return Math.max(1, Math.round(botRect.bottom - topRect.top));
    };

    ScrollTriggerPlugin.create({
      trigger,
      start: () => 'top top+=' + getHeaderOffset(),
      end: () => '+=' + measurePinScrollPx(),
      pin: true,
      pinSpacing: true,
      scrub: 1,
      invalidateOnRefresh: true,
      anticipatePin: 1,
      onUpdate: (/** @type {{ progress: number }} */ self) => {
        const index = Math.floor(self.progress * steps.length);
        activateStep(Math.min(index, steps.length - 1));
      }
    });

    currentIndex = -1;
    activateStep(0);
  }

  function tryInitAll() {
    if (initialized) return true;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!prefersReducedMotion) {
      const gsapLib = /** @type {any} */ (window)['gsap'];
      const ScrollTriggerPlugin = /** @type {any} */ (window)['ScrollTrigger'];
      if (!gsapLib || !ScrollTriggerPlugin) {
        return false;
      }
    }

    initialized = true;

    sectionWrappers.forEach((wrapper) => {
      initImpactTimelineSection(wrapper);
    });

    if (!prefersReducedMotion) {
      const ScrollTriggerPlugin = /** @type {any} */ (window)['ScrollTrigger'];
      const refresh = () => {
        ScrollTriggerPlugin.refresh();
      };
      if (document.readyState === 'complete') {
        requestAnimationFrame(refresh);
      } else {
        window.addEventListener('load', refresh, { once: true });
      }
    }

    return true;
  }

  if (!tryInitAll()) {
    window.addEventListener(
      'load',
      function onLoad() {
        window.removeEventListener('load', onLoad);
        if (!tryInitAll()) {
          console.warn('GSAP or ScrollTrigger not available after window load');
        }
      }
    );
  }
});
